import { Component, Input } from "@angular/core";
import { NavController } from "ionic-angular";
import { Hareline } from "../../models/interfaces/hareline.model";
import { Pledge } from "../../models/interfaces/pledge.model";
import { PledgePage } from "../../pages/pledge/pledge";
import { PledgeUpdatePage } from "../../pages/pledge/pledge_update";
import { PledgeAddPage } from "../../pages/pledge/pledge_add";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";

@Component({
  selector: "pledgecomponent",
  templateUrl: "pledgecomponent.html"
})
export class PledgeComponent {
  private hasAddPledgeAccess: boolean = false;

  @Input() pledge: any;
  @Input() hareline: Hareline;
  @Input() displayPic: boolean;
  @Input() page$: any;

  constructor(public authService: AuthService, public navCtrl: NavController,
              private db: DbserviceProvider) {
    console.log("PledgeComponent constructor");

    if (this.authService.currentUser) {
      this.hasAddPledgeAccess = this.db.hasAccess(PledgePage.PLEDGE_ADD_ACCESS);
    }
  }
  private addPledge(pledge: Pledge) {
    console.log("PledgePage addPledgse", pledge );
    if (this.hasAddPledgeAccess) {
      this.navCtrl.push(PledgeAddPage, {
        "pledge": pledge});
    }
  }


  private updatePledge(pledge: Pledge) {
    console.log("PledgePage updatePledge");
    if (this.hasAddPledgeAccess) {
      this.navCtrl.push(PledgeUpdatePage, {
        "pledge": pledge});
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pledgecomponent/pledgecomponent.ts